import { makeStyles } from "@mui/styles";
import {
  SURVEY_COLORS,
  SURVEY_SPACING,
  SURVEY_MIXINS,
  DATEPICKER_STYLES,
  SURVEY_TYPOGRAPHY,
} from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useDateFieldQuestionStyles = makeStyles(() => ({
  "@global": {
    ".k-animation-container": {
      zIndex: "10000 !important",
    },
  },
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
    width: "100%",
  },
  labelContainer: {
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  datePickerRoot: {
    width: "100%",
    position: "relative",
    zIndex: 1,
    "& .k-input": {
      backgroundColor: `${DATEPICKER_STYLES.backgroundColor} !important`,
      fontSize: `${DATEPICKER_STYLES.fontSize} !important`,
      fontFamily: `${DATEPICKER_STYLES.fontFamily} !important`,
      color: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& .k-input::placeholder": {
      fontSize: `${DATEPICKER_STYLES.fontSize} !important`,
      fontFamily: `${DATEPICKER_STYLES.fontFamily} !important`,
      fontWeight: "400 !important",
      opacity: "0.6 !important",
    },
  },
  hasError: {
    "& .k-dateinput-wrap": {
      border: `2px solid ${SURVEY_COLORS.ERROR} !important`,
    },
    "& .k-state-focused": {
      border: `2px solid ${SURVEY_COLORS.ERROR} !important`,
    },
  },
  hint: {
    fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_HINT,
    lineHeight: SURVEY_TYPOGRAPHY.LINE_HEIGHT_COMPACT,
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginTop: "4px",
  },
  label: {
    ...SURVEY_MIXINS.questionLabel,
    whiteSpace: "nowrap",
  },
  requiredAsterisk: {
    ...SURVEY_MIXINS.requiredAsterisk,
    display: "inline-block",
    lineHeight: "inherit",
    whiteSpace: "nowrap",
  },
}));
